import React, { useEffect } from "react";

const variantStyles = {
  success: { bg: "#2d5a3d", color: "#fff", icon: "✓" },
  error:   { bg: "#c62828", color: "#fff", icon: "✕" },
  info:    { bg: "#1565c0", color: "#fff", icon: "ℹ" },
};

function Snackbar({ message, variant = "success", onClose, duration = 3000 }) {
  const s = variantStyles[variant] || variantStyles.success;

  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 28,
        right: 28,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        gap: 10,
        backgroundColor: s.bg,
        color: s.color,
        padding: "12px 20px",
        borderRadius: 10,
        boxShadow: "0 4px 20px rgba(0,0,0,0.22)",
        fontSize: "0.9rem",
        fontWeight: 500,
        minWidth: 240,
        maxWidth: 400,
        animation: "snackbarIn 0.25s ease",
      }}
    >
      <style>{`@keyframes snackbarIn { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }`}</style>
      <span style={{ fontSize: "1rem" }}>{s.icon}</span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={onClose}
        style={{
          background: "none", border: "none", cursor: "pointer",
          color: s.color, fontSize: "0.95rem", padding: 0, opacity: 0.75,
        }}
      >
        ✕
      </button>
    </div>
  );
}

export default Snackbar;
